import { makeRequest, toCorrectFormDataValue, } from '@/js/libs/api';
import * as Types from './types';
import { encodeBody, fromDateType as fromDate, toDateType as toDate, fromDateTimeType as fromDateTime, toDateTimeUnixType as toDateTime, } from '@/js/libs/api-helpers';
export { fromDate, toDate, fromDateTime, toDateTime };
/** Get campaign position creatives. */ export const getCreativesByPositionSizes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.positionId === undefined) {
        throw new Error('Missing required parameter: positionId');
    }
    const path = '/api/ws-creatives/creatives-by-position-sizes';
    const pathInternal = '/api/creatives-by-position-sizes';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.accountId : (params.accountId ?? queryDefaults?.['accountId']);
        if (value !== undefined) {
            urlParams.append('accountId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    if (params.positionId !== undefined) {
        urlParams.append('positionId', params.positionId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativesByPositionSizes.paramsOrder = [{ type: 'parameters' }];
/** Updates creatives in batches. */ export const batchUpdateCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.uploadUuid === undefined) {
        throw new Error('Missing required parameter: uploadUuid');
    }
    if (params.creatives === undefined) {
        throw new Error('Missing required body: creatives');
    }
    const path = '/api/ws-creatives/batch/creatives';
    const pathInternal = '/api/batch/creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.uploadUuid !== undefined) {
        urlParams.append('uploadUuid', params.uploadUuid.toString());
    }
    if (params.creatives !== undefined) {
        body = params.creatives;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
batchUpdateCreative.paramsOrder = [{ type: 'body', paramName: 'creatives' }, { type: 'parameters' }];
/** Creates creatives in batches. */ export const batchCreateCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.uploadUuid === undefined) {
        throw new Error('Missing required parameter: uploadUuid');
    }
    if (params.creatives === undefined) {
        throw new Error('Missing required body: creatives');
    }
    const path = '/api/ws-creatives/batch/creatives';
    const pathInternal = '/api/batch/creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.uploadUuid !== undefined) {
        urlParams.append('uploadUuid', params.uploadUuid.toString());
    }
    if (params.creatives !== undefined) {
        body = params.creatives;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
batchCreateCreative.paramsOrder = [{ type: 'body', paramName: 'creatives' }, { type: 'parameters' }];
/** Creates creatives in batches. */ export const batchCreateCreativeFromFile = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-creatives/batch/creatives-file';
    const pathInternal = '/api/batch/creatives-file';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    if (params.uploadUuid !== undefined) {
        formData.append('uploadUuid', toCorrectFormDataValue(params.uploadUuid));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
batchCreateCreativeFromFile.paramsOrder = [{ type: 'formData' }];
/** Returns info about upload status */ export const batchCreativeUploadStatus = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.uploadUuid === undefined) {
        throw new Error('Missing required parameter: uploadUuid');
    }
    const path = '/api/ws-creatives/batch/creatives/status';
    const pathInternal = '/api/batch/creatives/status';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.uploadUuid !== undefined) {
        urlParams.append('uploadUuid', params.uploadUuid.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
batchCreativeUploadStatus.paramsOrder = [{ type: 'parameters' }];
/** Returns info about upload status */ export const batchCreativeUploadResult = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.uploadUuid === undefined) {
        throw new Error('Missing required parameter: uploadUuid');
    }
    const path = '/api/ws-creatives/batch/creatives-file-async';
    const pathInternal = '/api/batch/creatives-file-async';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.uploadUuid !== undefined) {
        urlParams.append('uploadUuid', params.uploadUuid.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
batchCreativeUploadResult.paramsOrder = [{ type: 'parameters' }];
/** Creates creatives in batches in async mode. Use batchCreativeUploadResult to get results and batchCreativeUploadStatus to get status. */ export const batchCreateCreativeFromFileAsync = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-creatives/batch/creatives-file-async';
    const pathInternal = '/api/batch/creatives-file-async';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    if (params.uploadUuid !== undefined) {
        formData.append('uploadUuid', toCorrectFormDataValue(params.uploadUuid));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'form-data',
    });
};
batchCreateCreativeFromFileAsync.paramsOrder = [{ type: 'formData' }];
/** Init batch uploading */ export const initBatchUploading = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-creatives/batch/creatives/init';
    const pathInternal = '/api/batch/creatives/init';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.uploadUuid : (params.uploadUuid ?? queryDefaults?.['uploadUuid']);
        if (value !== undefined) {
            urlParams.append('uploadUuid', value.toString());
        }
    }
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
initBatchUploading.paramsOrder = [{ type: 'parameters' }];
/** Marks finish of upload */ export const finishBatchUploadImage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.uploadUuid === undefined) {
        throw new Error('Missing required parameter: uploadUuid');
    }
    const path = '/api/ws-creatives/batch/creatives/images';
    const pathInternal = '/api/batch/creatives/images';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.uploadUuid !== undefined) {
        urlParams.append('uploadUuid', params.uploadUuid.toString());
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
finishBatchUploadImage.paramsOrder = [{ type: 'parameters' }];
/** Upload creative image files ni batch */ export const batchUploadImage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-creatives/batch/creatives/images';
    const pathInternal = '/api/batch/creatives/images';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.uploadUuid !== undefined) {
        formData.append('uploadUuid', toCorrectFormDataValue(params.uploadUuid));
    }
    if (params.accountId !== undefined) {
        formData.append('accountId', toCorrectFormDataValue(params.accountId));
    }
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    if (params.resumableChunkNumber !== undefined) {
        formData.append('resumableChunkNumber', toCorrectFormDataValue(params.resumableChunkNumber));
    }
    if (params.resumableTotalChunks !== undefined) {
        formData.append('resumableTotalChunks', toCorrectFormDataValue(params.resumableTotalChunks));
    }
    const headers = {};
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'form-data',
    });
};
batchUploadImage.paramsOrder = [{ type: 'formData' }];
/** Generate template with previously uploaded images */ export const getBatchTemplate = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.uploadUuid === undefined) {
        throw new Error('Missing required parameter: uploadUuid');
    }
    const path = '/api/ws-creatives/batch/creatives/images-template/{uploadUuid}'.replace('{uploadUuid}', params.uploadUuid?.toString());
    const pathInternal = '/api/batch/creatives/images-template/{uploadUuid}'.replace('{uploadUuid}', params.uploadUuid?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.format : (params.format ?? queryDefaults?.['format']);
        if (value !== undefined) {
            urlParams.append('format', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/octet-stream, application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
getBatchTemplate.paramsOrder = [{ type: 'parameters' }];
/** Export crawler generated creatives */ export const exportCreatives = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.crawlerConfigId === undefined) {
        throw new Error('Missing required parameter: crawlerConfigId');
    }
    const path = '/api/ws-creatives/batch/creatives/export/{crawlerConfigId}'.replace('{crawlerConfigId}', params.crawlerConfigId?.toString());
    const pathInternal = '/api/batch/creatives/export/{crawlerConfigId}'.replace('{crawlerConfigId}', params.crawlerConfigId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
exportCreatives.paramsOrder = [{ type: 'parameters' }];
/** Export native creatives by ids */ export const exportCreativesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeIds === undefined) {
        throw new Error('Missing required body: creativeIds');
    }
    const path = '/api/ws-creatives/batch/creatives/export';
    const pathInternal = '/api/batch/creatives/export';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativeIds !== undefined) {
        body = params.creativeIds;
    }
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
exportCreativesByIds.paramsOrder = [{ type: 'body', paramName: 'creativeIds' }];
/** Get campaign position creatives. */ export const getCreatives = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-creatives/creatives';
    const pathInternal = '/api/creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.page : (params.page ?? queryDefaults?.['page']);
        if (value !== undefined) {
            urlParams.append('page', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.limit : (params.limit ?? queryDefaults?.['limit']);
        if (value !== undefined) {
            urlParams.append('limit', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.sort : (params.sort ?? queryDefaults?.['sort']);
        if (value !== undefined) {
            urlParams.append('sort', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.order : (params.order ?? queryDefaults?.['order']);
        if (value !== undefined) {
            urlParams.append('order', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.accountId : (params.accountId ?? queryDefaults?.['accountId']);
        if (value !== undefined) {
            urlParams.append('accountId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.languageType : (params.languageType ?? queryDefaults?.['languageType']);
        if (value !== undefined) {
            urlParams.append('languageType', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.crawlerConfigId : (params.crawlerConfigId ?? queryDefaults?.['crawlerConfigId']);
        if (value !== undefined) {
            urlParams.append('crawlerConfigId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.creativeTypes : (params.creativeTypes ?? queryDefaults?.['creativeTypes']);
        if (value !== undefined) {
            urlParams.append('creativeTypes', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.creativeStatus : (params.creativeStatus ?? queryDefaults?.['creativeStatus']);
        if (value !== undefined) {
            urlParams.append('creativeStatus', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.companyId : (params.companyId ?? queryDefaults?.['companyId']);
        if (value !== undefined) {
            urlParams.append('companyId', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.filter : (params.filter ?? queryDefaults?.['filter']);
        if (value !== undefined) {
            urlParams.append('filter', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.includeInactive : (params.includeInactive ?? queryDefaults?.['includeInactive']);
        if (value !== undefined) {
            urlParams.append('includeInactive', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreatives.paramsOrder = [{ type: 'parameters' }];
/** Creates creative. */ export const createCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creative === undefined) {
        throw new Error('Missing required body: creative');
    }
    const path = '/api/ws-creatives/creatives';
    const pathInternal = '/api/creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creative !== undefined) {
        body = params.creative;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
createCreative.paramsOrder = [{ type: 'body', paramName: 'creative' }];
/** Validate creative. */ export const validateCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creative === undefined) {
        throw new Error('Missing required body: creative');
    }
    const path = '/api/ws-creatives/creatives/validate';
    const pathInternal = '/api/creatives/validate';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creative !== undefined) {
        body = params.creative;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
validateCreative.paramsOrder = [{ type: 'body', paramName: 'creative' }];
/** Returns number of creatives by status */ export const countCreatives = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeStatus === undefined) {
        throw new Error('Missing required parameter: creativeStatus');
    }
    const path = '/api/ws-creatives/creatives/count';
    const pathInternal = '/api/creatives/count';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativeStatus !== undefined) {
        urlParams.append('creativeStatus', params.creativeStatus.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
countCreatives.paramsOrder = [{ type: 'parameters' }];
export const updateCreativeCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    if (params.campaignPositionIds === undefined) {
        throw new Error('Missing required body: campaignPositionIds');
    }
    const path = '/api/ws-creatives/creatives/{creativeId}/link'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}/link'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.campaignPositionIds !== undefined) {
        body = params.campaignPositionIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreativeCampaignPositions.paramsOrder = [
    { type: 'body', paramName: 'campaignPositionIds' },
    { type: 'parameters' },
];
export const updateCreativesCampaignPositions = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativesPositions === undefined) {
        throw new Error('Missing required body: creativesPositions');
    }
    const path = '/api/ws-creatives/creatives/link';
    const pathInternal = '/api/creatives/link';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativesPositions !== undefined) {
        body = params.creativesPositions;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreativesCampaignPositions.paramsOrder = [{ type: 'body', paramName: 'creativesPositions' }];
export const updateCreativesStatuses = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativesStatusesDto === undefined) {
        throw new Error('Missing required body: creativesStatusesDto');
    }
    const path = '/api/ws-creatives/creatives/statuses';
    const pathInternal = '/api/creatives/statuses';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativesStatusesDto !== undefined) {
        body = params.creativesStatusesDto;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreativesStatuses.paramsOrder = [{ type: 'body', paramName: 'creativesStatusesDto' }];
export const getCreativePreview = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-creatives/creatives/preview';
    const pathInternal = '/api/creatives/preview';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativeId !== undefined) {
        urlParams.append('creativeId', params.creativeId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativePreview.paramsOrder = [{ type: 'parameters' }];
export const findCreativeById = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-creatives/creatives/{creativeId}'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findCreativeById.paramsOrder = [{ type: 'parameters' }];
export const updateCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    if (params.creative === undefined) {
        throw new Error('Missing required body: creative');
    }
    const path = '/api/ws-creatives/creatives/{creativeId}'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creative !== undefined) {
        body = params.creative;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateCreative.paramsOrder = [{ type: 'body', paramName: 'creative' }, { type: 'parameters' }];
export const deleteCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-creatives/creatives/{creativeId}'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCreative.paramsOrder = [{ type: 'parameters' }];
export const cloneCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-creatives/creatives/{creativeId}/clone'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}/clone'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
cloneCreative.paramsOrder = [{ type: 'parameters' }];
export const approveCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-creatives/creatives/{creativeId}/approve'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}/approve'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
approveCreative.paramsOrder = [{ type: 'parameters' }];
export const resumeCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-creatives/creatives/{creativeId}/resume'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}/resume'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
resumeCreative.paramsOrder = [{ type: 'parameters' }];
export const rejectCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    const path = '/api/ws-creatives/creatives/{creativeId}/reject'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}/reject'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
rejectCreative.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
export const suspendCreative = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-creatives/creatives/{creativeId}/suspend'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}/suspend'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
suspendCreative.paramsOrder = [{ type: 'parameters' }];
/** Sync/re-push approved creatives to ad server ensures creatives with missing adServerId are in sync */ export const syncCreativesToAdServer = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeIds === undefined) {
        throw new Error('Missing required body: creativeIds');
    }
    const path = '/api/ws-creatives/creatives/sync-to-adserver';
    const pathInternal = '/api/creatives/sync-to-adserver';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativeIds !== undefined) {
        body = params.creativeIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
syncCreativesToAdServer.paramsOrder = [{ type: 'body', paramName: 'creativeIds' }];
/** Delete creatives by list of ids */ export const deleteCreatives = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeIds === undefined) {
        throw new Error('Missing required parameter: creativeIds');
    }
    const path = '/api/ws-creatives/creatives/delete';
    const pathInternal = '/api/creatives/delete';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativeIds !== undefined) {
        urlParams.append('creativeIds', params.creativeIds.toString());
    }
    const headers = {};
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'DELETE',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
deleteCreatives.paramsOrder = [{ type: 'parameters' }];
export const addAdServerId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    if (params.adServerType === undefined) {
        throw new Error('Missing required parameter: adServerType');
    }
    if (params.adServerId === undefined) {
        throw new Error('Missing required parameter: adServerId');
    }
    const path = '/api/ws-creatives/creatives/{creativeId}/add-ad-server-id/{adServerType}/{adServerId}'
        .replace('{creativeId}', params.creativeId?.toString())
        .replace('{adServerType}', params.adServerType?.toString())
        .replace('{adServerId}', params.adServerId?.toString());
    const pathInternal = '/api/creatives/{creativeId}/add-ad-server-id/{adServerType}/{adServerId}'
        .replace('{creativeId}', params.creativeId?.toString())
        .replace('{adServerType}', params.adServerType?.toString())
        .replace('{adServerId}', params.adServerId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addAdServerId.paramsOrder = [{ type: 'parameters' }];
export const removeCreativeFromXandr = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    if (params.companyId === undefined) {
        throw new Error('Missing required parameter: companyId');
    }
    const path = '/api/ws-creatives/creatives/{creativeId}/remove-from-xandr'.replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/creatives/{creativeId}/remove-from-xandr'.replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.companyId !== undefined) {
        urlParams.append('companyId', params.companyId.toString());
    }
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
removeCreativeFromXandr.paramsOrder = [{ type: 'parameters' }];
export const findCreativesByIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeIds === undefined) {
        throw new Error('Missing required body: creativeIds');
    }
    const path = '/api/ws-creatives/creatives/by-ids';
    const pathInternal = '/api/creatives/by-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativeIds !== undefined) {
        body = params.creativeIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findCreativesByIds.paramsOrder = [{ type: 'body', paramName: 'creativeIds' }];
export const getCreativesWithAdServerIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeIds === undefined) {
        throw new Error('Missing required body: creativeIds');
    }
    const path = '/api/ws-creatives/creatives/with-adserver-ids';
    const pathInternal = '/api/creatives/with-adserver-ids';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.creativeIds !== undefined) {
        body = params.creativeIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativesWithAdServerIds.paramsOrder = [{ type: 'body', paramName: 'creativeIds' }];
export const findCreativesByAdServerIds = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.adServerType === undefined) {
        throw new Error('Missing required parameter: adServerType');
    }
    if (params.adServerCreativeIds === undefined) {
        throw new Error('Missing required body: adServerCreativeIds');
    }
    const path = '/api/ws-creatives/creatives/by-ad-server-ids/{adServerType}'.replace('{adServerType}', params.adServerType?.toString());
    const pathInternal = '/api/creatives/by-ad-server-ids/{adServerType}'.replace('{adServerType}', params.adServerType?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.adServerCreativeIds !== undefined) {
        body = params.adServerCreativeIds;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
findCreativesByAdServerIds.paramsOrder = [
    { type: 'body', paramName: 'adServerCreativeIds' },
    { type: 'parameters' },
];
/** Upload creative image file to specified creative or create new one with uploaded image */ export const uploadImage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.creativeType === undefined) {
        throw new Error('Missing required parameter: creativeType');
    }
    if (params.imageType === undefined) {
        throw new Error('Missing required parameter: imageType');
    }
    const path = '/api/ws-creatives/creatives/images';
    const pathInternal = '/api/creatives/images';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    if (params.creativeType !== undefined) {
        urlParams.append('creativeType', params.creativeType.toString());
    }
    if (params.imageType !== undefined) {
        urlParams.append('imageType', params.imageType.toString());
    }
    {
        const value = queryDefaults === false ? params.x : (params.x ?? queryDefaults?.['x']);
        if (value !== undefined) {
            urlParams.append('x', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.y : (params.y ?? queryDefaults?.['y']);
        if (value !== undefined) {
            urlParams.append('y', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.zoom : (params.zoom ?? queryDefaults?.['zoom']);
        if (value !== undefined) {
            urlParams.append('zoom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.width : (params.width ?? queryDefaults?.['width']);
        if (value !== undefined) {
            urlParams.append('width', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.height : (params.height ?? queryDefaults?.['height']);
        if (value !== undefined) {
            urlParams.append('height', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.uploadUuid : (params.uploadUuid ?? queryDefaults?.['uploadUuid']);
        if (value !== undefined) {
            urlParams.append('uploadUuid', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadImage.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
/** Generate creative image by text prompt using Gemini Nano Banana */ export const generateImageWithGemini = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.prompt === undefined) {
        throw new Error('Missing required parameter: prompt');
    }
    const path = '/api/ws-creatives/creatives/images/generate';
    const pathInternal = '/api/creatives/images/generate';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.prompt !== undefined) {
        urlParams.append('prompt', params.prompt.toString());
    }
    {
        const value = queryDefaults === false ? params.creativeType : (params.creativeType ?? queryDefaults?.['creativeType']);
        if (value !== undefined) {
            urlParams.append('creativeType', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.imageType : (params.imageType ?? queryDefaults?.['imageType']);
        if (value !== undefined) {
            urlParams.append('imageType', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
generateImageWithGemini.paramsOrder = [{ type: 'parameters' }];
/** Upload creative image file to CDN */ export const uploadImageToCdn = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-creatives/creatives/images/cdn';
    const pathInternal = '/api/creatives/images/cdn';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadImageToCdn.paramsOrder = [{ type: 'formData' }];
/** Get creative image preview */ export const getPreview = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-creatives/creatives/images/{id}/preview'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/creatives/images/{id}/preview'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.x : (params.x ?? queryDefaults?.['x']);
        if (value !== undefined) {
            urlParams.append('x', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.y : (params.y ?? queryDefaults?.['y']);
        if (value !== undefined) {
            urlParams.append('y', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.zoom : (params.zoom ?? queryDefaults?.['zoom']);
        if (value !== undefined) {
            urlParams.append('zoom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.width : (params.width ?? queryDefaults?.['width']);
        if (value !== undefined) {
            urlParams.append('width', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.height : (params.height ?? queryDefaults?.['height']);
        if (value !== undefined) {
            urlParams.append('height', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getPreview.paramsOrder = [{ type: 'parameters' }];
/** Upload creative video file to specified creative or create new one with uploaded asset */ export const uploadVideo = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.videoType === undefined) {
        throw new Error('Missing required parameter: videoType');
    }
    const path = '/api/ws-creatives/creatives/video';
    const pathInternal = '/api/creatives/video';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    if (params.videoType !== undefined) {
        urlParams.append('videoType', params.videoType.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadVideo.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
/** Upload creative image file by url to specified creative or create new one with uploaded image */ export const uploadImageByUrl = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.imageUrl === undefined) {
        throw new Error('Missing required parameter: imageUrl');
    }
    if (params.creativeType === undefined) {
        throw new Error('Missing required parameter: creativeType');
    }
    if (params.imageType === undefined) {
        throw new Error('Missing required parameter: imageType');
    }
    const path = '/api/ws-creatives/creatives/images/upload-by-url';
    const pathInternal = '/api/creatives/images/upload-by-url';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.imageUrl !== undefined) {
        urlParams.append('imageUrl', params.imageUrl.toString());
    }
    if (params.creativeType !== undefined) {
        urlParams.append('creativeType', params.creativeType.toString());
    }
    if (params.imageType !== undefined) {
        urlParams.append('imageType', params.imageType.toString());
    }
    {
        const value = queryDefaults === false ? params.x : (params.x ?? queryDefaults?.['x']);
        if (value !== undefined) {
            urlParams.append('x', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.y : (params.y ?? queryDefaults?.['y']);
        if (value !== undefined) {
            urlParams.append('y', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.zoom : (params.zoom ?? queryDefaults?.['zoom']);
        if (value !== undefined) {
            urlParams.append('zoom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.width : (params.width ?? queryDefaults?.['width']);
        if (value !== undefined) {
            urlParams.append('width', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.height : (params.height ?? queryDefaults?.['height']);
        if (value !== undefined) {
            urlParams.append('height', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
uploadImageByUrl.paramsOrder = [{ type: 'parameters' }];
/** Update creative image file */ export const updateImage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.id === undefined) {
        throw new Error('Missing required parameter: id');
    }
    const path = '/api/ws-creatives/creatives/images/{id}'.replace('{id}', params.id?.toString());
    const pathInternal = '/api/creatives/images/{id}'.replace('{id}', params.id?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.x : (params.x ?? queryDefaults?.['x']);
        if (value !== undefined) {
            urlParams.append('x', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.y : (params.y ?? queryDefaults?.['y']);
        if (value !== undefined) {
            urlParams.append('y', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.zoom : (params.zoom ?? queryDefaults?.['zoom']);
        if (value !== undefined) {
            urlParams.append('zoom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.width : (params.width ?? queryDefaults?.['width']);
        if (value !== undefined) {
            urlParams.append('width', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.height : (params.height ?? queryDefaults?.['height']);
        if (value !== undefined) {
            urlParams.append('height', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
updateImage.paramsOrder = [{ type: 'parameters' }];
/** Get available image sizes */ export const getImageSizes = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-creatives/creatives/images/image-sizes';
    const pathInternal = '/api/creatives/images/image-sizes';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getImageSizes.paramsOrder = [];
/** Add custom image size */ export const addCustomImageSize = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.imageSize === undefined) {
        throw new Error('Missing required body: imageSize');
    }
    const path = '/api/ws-creatives/creatives/images/image-sizes';
    const pathInternal = '/api/creatives/images/image-sizes';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.imageSize !== undefined) {
        body = params.imageSize;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
addCustomImageSize.paramsOrder = [{ type: 'body', paramName: 'imageSize' }];
/** Upload creative image file */ export const uploadSingleNativeImage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.imageType === undefined) {
        throw new Error('Missing required parameter: imageType');
    }
    const path = '/api/ws-creatives/public/creatives/native/images';
    const pathInternal = '/api/public/creatives/native/images';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    if (params.imageType !== undefined) {
        urlParams.append('imageType', params.imageType.toString());
    }
    {
        const value = queryDefaults === false ? params.x : (params.x ?? queryDefaults?.['x']);
        if (value !== undefined) {
            urlParams.append('x', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.y : (params.y ?? queryDefaults?.['y']);
        if (value !== undefined) {
            urlParams.append('y', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.zoom : (params.zoom ?? queryDefaults?.['zoom']);
        if (value !== undefined) {
            urlParams.append('zoom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.width : (params.width ?? queryDefaults?.['width']);
        if (value !== undefined) {
            urlParams.append('width', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.height : (params.height ?? queryDefaults?.['height']);
        if (value !== undefined) {
            urlParams.append('height', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadSingleNativeImage.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
/** Upload creative image file to specified creative with all image types */ export const uploadSingleNativeImageAsAllTypes = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-creatives/public/creatives/native/images/as-all-types';
    const pathInternal = '/api/public/creatives/native/images/as-all-types';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    {
        const value = queryDefaults === false ? params.x : (params.x ?? queryDefaults?.['x']);
        if (value !== undefined) {
            urlParams.append('x', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.y : (params.y ?? queryDefaults?.['y']);
        if (value !== undefined) {
            urlParams.append('y', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.zoom : (params.zoom ?? queryDefaults?.['zoom']);
        if (value !== undefined) {
            urlParams.append('zoom', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.width : (params.width ?? queryDefaults?.['width']);
        if (value !== undefined) {
            urlParams.append('width', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.height : (params.height ?? queryDefaults?.['height']);
        if (value !== undefined) {
            urlParams.append('height', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadSingleNativeImageAsAllTypes.paramsOrder = [{ type: 'formData' }, { type: 'parameters' }];
/** Upload html asset for HtmlCreative */ export const uploadHtmlAsset = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-creatives/creatives/html/assets';
    const pathInternal = '/api/creatives/html/assets';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.file !== undefined) {
        formData.append('file', toCorrectFormDataValue(params.file));
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'multipart/form-data';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: formData,
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'form-data',
    });
};
uploadHtmlAsset.paramsOrder = [{ type: 'formData' }];
/** Get creative image file */ export const downloadCreativeImage = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.name === undefined) {
        throw new Error('Missing required parameter: name');
    }
    const path = '/api/ws-creatives/creatives/images/{name}'.replace('{name}', params.name?.toString());
    const pathInternal = '/api/creatives/images/{name}'.replace('{name}', params.name?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
downloadCreativeImage.paramsOrder = [{ type: 'parameters' }];
/** Get html creative asset */ export const downloadHtmlCreativeAsset = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.name === undefined) {
        throw new Error('Missing required parameter: name');
    }
    const path = '/api/ws-creatives/creatives/html/assets/{name}'.replace('{name}', params.name?.toString());
    const pathInternal = '/api/creatives/html/assets/{name}'.replace('{name}', params.name?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
downloadHtmlCreativeAsset.paramsOrder = [{ type: 'parameters' }];
/** Get html creative asset */ export const downloadVideoCreativeAsset = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.name === undefined) {
        throw new Error('Missing required parameter: name');
    }
    const path = '/api/ws-creatives/creatives/video/assets/{name}'.replace('{name}', params.name?.toString());
    const pathInternal = '/api/creatives/video/assets/{name}'.replace('{name}', params.name?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/octet-stream';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'blob',
        requestType: 'json',
    });
};
downloadVideoCreativeAsset.paramsOrder = [{ type: 'parameters' }];
/** Get company names of creatives */ export const getCreativesCompanyNames = async ({ onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-creatives/creatives/company-names';
    const pathInternal = '/api/creatives/company-names';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCreativesCompanyNames.paramsOrder = [];
/** Returns a list of campaign positions by account. */ export const getCampaignPositionsByAccountAndSize = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-creatives/accounts/{accountId}/campaign-positions-by-sizes'.replace('{accountId}', params.accountId?.toString());
    const pathInternal = '/api/accounts/{accountId}/campaign-positions-by-sizes'.replace('{accountId}', params.accountId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    {
        const value = queryDefaults === false ? params.campaignId : (params.campaignId ?? queryDefaults?.['campaignId']);
        if (value !== undefined) {
            urlParams.append('campaignId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignPositionsByAccountAndSize.paramsOrder = [
    { type: 'body', paramName: 'form' },
    { type: 'parameters' },
];
/** Returns a list of campaigns by account. */ export const getCampaignsByAccount = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.form === undefined) {
        throw new Error('Missing required body: form');
    }
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    const path = '/api/ws-creatives/accounts/{accountId}/campaigns'.replace('{accountId}', params.accountId?.toString());
    const pathInternal = '/api/accounts/{accountId}/campaigns'.replace('{accountId}', params.accountId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCampaignsByAccount.paramsOrder = [{ type: 'body', paramName: 'form' }, { type: 'parameters' }];
/** Returns a list of creatives info per crawler config. */ export const getCrawlerConfigCreativesInfo = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-creatives/crawler-configs/creatives';
    const pathInternal = '/api/crawler-configs/creatives';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.form !== undefined) {
        body = params.form;
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    headers['Content-Type'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: encodeBody(body),
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getCrawlerConfigCreativesInfo.paramsOrder = [{ type: 'body', paramName: 'form' }];
/** Remove creative from position */ export const removeCreativeFromCampaignPosition = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.campaignPositionId === undefined) {
        throw new Error('Missing required parameter: campaignPositionId');
    }
    if (params.creativeId === undefined) {
        throw new Error('Missing required parameter: creativeId');
    }
    const path = '/api/ws-creatives/campaign-positions/{campaignPositionId}/remove-creative/{creativeId}'
        .replace('{campaignPositionId}', params.campaignPositionId?.toString())
        .replace('{creativeId}', params.creativeId?.toString());
    const pathInternal = '/api/campaign-positions/{campaignPositionId}/remove-creative/{creativeId}'
        .replace('{campaignPositionId}', params.campaignPositionId?.toString())
        .replace('{creativeId}', params.creativeId?.toString());
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    const headers = {};
    return makeRequest({
        ...otherParams,
        method: 'PUT',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
removeCreativeFromCampaignPosition.paramsOrder = [{ type: 'parameters' }];
/** Replace old account id with new one. */ export const replaceAccountId = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    if (params.accountId === undefined) {
        throw new Error('Missing required parameter: accountId');
    }
    if (params.newAccountId === undefined) {
        throw new Error('Missing required parameter: newAccountId');
    }
    const path = '/api/ws-creatives/accounts/replace-account-id';
    const pathInternal = '/api/accounts/replace-account-id';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    if (params.accountId !== undefined) {
        urlParams.append('accountId', params.accountId.toString());
    }
    if (params.newAccountId !== undefined) {
        urlParams.append('newAccountId', params.newAccountId.toString());
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'POST',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'void',
        requestType: 'json',
    });
};
replaceAccountId.paramsOrder = [{ type: 'parameters' }];
/** Returns all owned accounts */ export const getAllOwnedAccountsShort = async ({ params, onUploadProgress, signal, baseURL, isInternal, headers: headersParam = {}, queryDefaults, ...otherParams }) => {
    const path = '/api/ws-creatives/all-accounts/short';
    const pathInternal = '/api/all-accounts/short';
    let body = {};
    const formData = new FormData();
    const urlParams = new URLSearchParams();
    {
        const value = queryDefaults === false ? params.prefix : (params.prefix ?? queryDefaults?.['prefix']);
        if (value !== undefined) {
            urlParams.append('prefix', value.toString());
        }
    }
    {
        const value = queryDefaults === false ? params.role : (params.role ?? queryDefaults?.['role']);
        if (value !== undefined) {
            urlParams.append('role', value.toString());
        }
    }
    {
        const value = queryDefaults === false
            ? params.includedAccountId
            : (params.includedAccountId ?? queryDefaults?.['includedAccountId']);
        if (value !== undefined) {
            urlParams.append('includedAccountId', value.toString());
        }
    }
    const headers = {};
    headers['Accept'] = 'application/json';
    return makeRequest({
        ...otherParams,
        method: 'GET',
        url: isInternal ? pathInternal : path,
        params: urlParams,
        data: {},
        onUploadProgress,
        signal,
        baseURL: baseURL || undefined,
        headers: { ...headers, ...headersParam },
        responseTypes: 'json',
        requestType: 'json',
    });
};
getAllOwnedAccountsShort.paramsOrder = [{ type: 'parameters' }];
export * from './types';
export * from './constants';
